import TvCampaignParams from './TvCampaignParams';

export default TvCampaignParams;
